import React from "react";
import styled from "styled-components";

export interface PaperProps extends React.HTMLAttributes<HTMLDivElement> {
    elevation?: number;
    children?: React.ReactNode;
}

const PaperRoot = styled.div<PaperProps>`
    background-color: ${({ theme }) => theme.palette.white};
    border-radius: 0.5rem;
    padding: 1.5rem;
    box-shadow: ${({ elevation }) => {
        if (elevation === 0) return "none";
        if (elevation === 1) return "0 1px 3px rgba(0,0,0,0.12)";
        if (elevation === 2) return "0 2px 6px rgba(0,0,0,0.12)";
        return "0 4px 12px rgba(0,0,0,0.15)";
    }};
`;

export const Paper: React.FC<PaperProps> = ({ children, elevation = 1, ...props }) => {
    return (
        <PaperRoot elevation={elevation} {...props}>
            {children}
        </PaperRoot>
    );
};

export default Paper;


